import React from 'react';
import { Box, Flex, Image } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

const Items = ({ items }) => (
  <Flex
    mr={[null, null, -6]}
    mb={[-6, null, 0]}
    my="8"
    flexDirection={['column', null, 'row']}
  >
    {items.map(({ key, icon, title, description, cta, label, titleId }) => (
      <Box
        width={[null, null, 'calc(calc(100% - 64px) / 3)']}
        mr={[null, null, 6]}
        mb={[6, null, 0]}
        key={key}
      >
        <Flex height={['36px', null, '48px']} alignItems="center">
          <Box flexBasis={['30px', null, '40px']} mr={['3', null, '4']}>
            <Image src={icon} alt={title} />
          </Box>
          <Box flex="1">
            <Box id={titleId} fontSize="md" fontWeight="bold">
              {title}
            </Box>
          </Box>
        </Flex>
        <Flex>
          <Box flexBasis={['30px', null, '40px']} mr={['3', null, '4']} />
          <Box flex="1">
            <Box mb="10" mt="2">
              {description}
            </Box>
            {label && (
              <Box fontWeight="600" mb="4">
                {label}
              </Box>
            )}
            {cta}
          </Box>
        </Flex>
      </Box>
    ))}
  </Flex>
);

Items.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      icon: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      cta: PropTypes.node,
    }),
  ).isRequired,
};

export default Items;
